import { Scene, Light, HemisphericLight, Vector3, Observable, CubeTexture } from '@babylonjs/core';
import ObservablesManager from './ObservablesManager';

export default class LightFactory {
	private scene: Scene;
	private observablesManager: ObservablesManager;

	constructor(scene: Scene, observablesManager: ObservablesManager) {
		this.scene = scene;
		this.observablesManager = observablesManager;
	}

	/**
	 * Will notify when the light was created.
	 */
	public get onLightCreated(): Observable<Light> {
		return this.observablesManager.onLightCreatedObservable;
	}

	/**
	 * Creates light.
	 */
	public createLight(direction: Vector3, intensity: number): void {
		const light = new HemisphericLight('light', direction, this.scene);
		light.intensity = intensity;
	}

	/**
	 * Creates Environment.
	 */
	public createEnvironment(url: string): void {
		const cubeTexture = CubeTexture.CreateFromPrefilteredData(url, this.scene);
		this.scene.environmentTexture = cubeTexture;
	}
}
